import { Suspense, useState, startTransition, useImperativeHandle, useRef, useEffect, createContext, useLayoutEffect } from "react"
import { ShowVariations } from "components/model/model-majesty/style"
import useScrollLock from "hooks/useScrollLock"
import { useHeader } from "contexts/Header"
import { useSubNav } from "contexts/SubNav"
import { FocusScope } from "@react-aria/focus"
import styled from "@emotion/styled"
import { LAUNCH_ROUTE } from "./constants"
import getMediaQuery from "css/breakpoints"
import { useLocale } from "contexts/Locale"
import { useDictionary } from "contexts/Dictionary"
import { buttonText, buttonReset, buttonIcon, translucentDark } from "css/buttons"
import { createPortal } from "react-dom"
import { Icon } from "components/icon/Icon"
import ModelVariations from "./ModelVariations"
import { WatchVariationsContextProvider } from "./context"
import { useConsole } from "contexts/Console"

const Close = styled.button`
  ${buttonIcon}
  ${translucentDark}
  --spacing: calc(var(--outer-margin) - var(--height) / 2);
  ${getMediaQuery("m")} {
    --spacing: 3.125rem;
  }
  inset-block-start: var(--spacing);
  inset-inline-end: var(--spacing);
  position: absolute;
  z-index: 29;
`

function ModelVariationsPlayer({ children, kill, rmc, family, route, variations, cta }) {
  const [active, setActive] = useState(null)

  const ctx = createContext()

  useLayoutEffect(() => {
    setActive(
      route ? (
        <WatchVariationsContextProvider Ctx={ctx} kill={kill} entry={rmc} active={rmc} route={route} family={family} variations={variations} mode='cover'>
          <ModelVariations ctx={ctx} cta={cta}>{children}</ModelVariations>
        </WatchVariationsContextProvider>
      ) : null
    )
  }, [route])

  return process.browser && active ? createPortal(active, document.body) : null
}

function toValidHash(h) {
  if (!h) return null
  const [start] = h.split("/")
  if (start === "cfg") return null
  return h
}

export default function ModelVariationsLauncher({ children, style, disabled, rmc, family, variations, ...props }) {
  //console.log("Launcherrr", style, disabled, rmc, family)
  const [hash, setHash] = useState(process.browser ? window.location.hash.split("").slice(1).join("") : "")
  const dictionary = useDictionary()
  const cta = useRef(null)

  function kill() {
    if (!process.browser) return
    window.history.pushState({}, "", window.location.href.split("#")[0])
    setHash(null)
    if (cta.current) {
      setTimeout(() => {
        cta.current.focus()
        cta.current = null
      }, 100)
    }
  }

  function onClick(e) {
    cta.current = e?.target
    setHash(LAUNCH_ROUTE)
  }

  useEffect(() => {
    const onkeydown = e => {
      if ((e.key === "Escape" || e.keyCode === 27) && !!hash) {
        e.preventDefault()
        kill()
      }
    }

    global.addEventListener("keydown", onkeydown)

    return () => {
      global.removeEventListener("keydown", onkeydown)
    }
  }, [hash])

  return (
    <>
      <ShowVariations type='button' onClick={onClick} style={style} disabled={disabled}>
        {children}
      </ShowVariations>
      <ModelVariationsPlayer kill={kill} rmc={rmc} family={family} variations={variations} route={toValidHash(hash)} cta={cta}>
        <Close onClick={kill} aria-label={dictionary.popinClose()}>
          <Icon type='close' />
        </Close>
      </ModelVariationsPlayer>
    </>
  )
}
